export const bvmWebsocketCommands = {
    //route (commands)
    BVM_DATA_GET: 'loadBvmData',

    //receive
    BVM_DATA_SEND: 'BVM_DATA_SEND',
    BVM_DATA_SEND_ERROR: 'BVM_DATA_SEND_ERROR',
    BVM_DATA_SEND_WARN: 'BVM_DATA_SEND_WARN',
};
